/**
 * NetworkERC3643Hero — the `/network/erc-3643` design.
 *
 * Verbatim render of `network-erc-3643.html` (modules in
 * ./landing/network-erc-3643/).
 */
import { STYLES } from "./landing/network-erc-3643/styles";
import { MARKUP } from "./landing/network-erc-3643/markup";
import { SCRIPT } from "./landing/network-erc-3643/script";
import { PageHost } from "./landing/PageHost";

export function NetworkERC3643Hero() {
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-erc3643-host"
      wireLinks={true}
      data-testid="network-erc-3643-hero"
    />
  );
}
